"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HandleUtils = void 0;
exports.HandleUtils = {
    combine: function (first, second) {
        return {
            cancel: function () {
                first.cancel();
                second.cancel();
            }
        };
    }
};
//# sourceMappingURL=handle.js.map